import { hbs } from 'ember-cli-htmlbars';
export default hbs("{{#if @enableClicking}}\n  <a href=\"#\" {{fn this.selectForDrag}}>\n    {{yield}}\n  </a>\n{{else}}\n  {{yield}}\n{{/if}}")